import { render, staticRenderFns } from "./RestDayEdit.vue?vue&type=template&id=1682aa71"
import script from "./RestDayEdit.vue?vue&type=script&lang=js"
export * from "./RestDayEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports